import { render, staticRenderFns } from "./SGPFlowTimelineComponent.vue?vue&type=template&id=5b9ed6ab"
import script from "./SGPFlowTimelineComponent.vue?vue&type=script&lang=js"
export * from "./SGPFlowTimelineComponent.vue?vue&type=script&lang=js"
import style0 from "./SGPFlowTimelineComponent.vue?vue&type=style&index=0&id=5b9ed6ab&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports